import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormView } from '@form/cer-form-view';

import { RefDataProductInboundContributorForm } from './refdata-product-inbound-contributor.form';
import { RefDataProductInboundCurrentForm } from './refdata-product-inbound-current.form';

export const RecordReference = "recordReference";

export class RefDataProductInboundForm extends CerFormAdapter {

  override viewSetInit(viewSet: CerFormViewSet): void {

    const view = this.productViewGet();
    const contributorView = RefDataProductInboundContributorForm.contributorView(true);
    contributorView.paneTarget = 'right';
    viewSet.viewAdd(view);
    viewSet.viewAdd(contributorView, view);
  }

  public productViewGet(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'titler-bop', dataApiName: 'RefDataProductInbound',
        text: 'Titel historik BOP', textSingular: 'Titel historik BOP',
        titleFields: [RecordReference],
        primaryKey: 'id', baseFields: ['id'],
        allowEdit: false, allowCreate: false, allowDelete: false,
        navigations: [
          { link: 'nav', foreignKey: { parentEntity: 'RefDataProductInboundCurrent', parentColumn: RecordReference, column: RecordReference } },
          //{ link: 'nav', foreignKey: { parentEntity: 'RefDataProductInboundContributorCurrent', parentColumn: InboundId, column: Id } },
          { link: 'nav', foreignKey: { parentEntity: 'DataJobLog', parentColumn: 'id', column: 'modifiedJobId' } }
        ]
      },
      fieldMetadata: RefDataProductInboundCurrentForm.fieldMetadata()
    });
  }
}

